import { Container, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { useImportedVehiclesQuery } from '../../../api/graphql/generated/hooks';
import { PageHeader } from '../../../components';
import { AppPageNameRoutes } from '../../../routes/paths';
import { RouteComponentProps } from 'react-router-dom';
import ImportedVehicleFilters, { type Filters as FiltersInput } from './filter/ImportedVehicleFilters';
import ImportedVehicleDefinitionTable from './table/ImportedVehicleDefinitionTable';
import { setLoadingStatus } from '../../../redux/loading';
import { useDispatch } from 'react-redux';
import { ImportedVehiclesQueryVariables } from '../../../api/graphql/generated/operations';
import { ImportStateEnum } from '../../../api/graphql/generated/schema';

const breadcrumbs = [AppPageNameRoutes.IMPORTED_VEHICLE_DEFINITIONS];

type PageProps = RouteComponentProps<void>;

type Pagination = {
  offset: number;
  rowsPerPage: number;
};

function ImportedVehicleDefinitions(props: PageProps) {
  const dispatch = useDispatch();
  const [pagination, setPagination] = useState<Pagination>({ offset: 0, rowsPerPage: 25 });
  const [filters, setFilters] = useState<ImportedVehiclesQueryVariables['filter']>({
    importStates: [ImportStateEnum.NoCard],
  });
  const { data, loading } = useImportedVehiclesQuery({
    variables: {
      offset: pagination.offset,
      limit: pagination.rowsPerPage,
      filter: filters,
    },
  });

  const handleFiltersChanged = (filters: FiltersInput) => {
    setFilters(() => {
      return {
        vin: filters.vin || undefined,
        brandId: filters.brandId || undefined,
        importStates:
          filters.states && filters.states.filter(Boolean).length > 0 ? filters.states.filter(Boolean) : undefined,
      } satisfies ImportedVehiclesQueryVariables['filter'];
    });
  };

  useEffect(() => {
    dispatch(setLoadingStatus(loading));
  }, [loading, dispatch]);

  const handlePaginationChange = (newPage) => {
    setPagination((prev) => ({ ...prev, ...newPage }));
  };

  return (
    <Container className='page vehicle-card'>
      <Grid justifyContent={'space-between'}>
        <Grid
          item
          justifyContent={'flex-end'}
          className='text-left'
        >
          {/* TODO: Force import by calling CML */}
          {/* <Button
            startIcon={<Add />}
            // onClick={handleNewCard}
            className=' button new-card'
          >
            {t('pages.usedVehicleCards.createUsedVehicleCard')}
          </Button> */}
          <PageHeader
            headline={'importedCars'}
            breadcrumbs={breadcrumbs}
          />
        </Grid>
      </Grid>
      <ImportedVehicleFilters onFiltersChange={handleFiltersChanged} />
      <ImportedVehicleDefinitionTable
        dataPage={data?.getImportedVehicleDefinitions}
        handleChangePage={(_, page) => handlePaginationChange({ offset: page * pagination.rowsPerPage })}
        handleChangeRowsPerPage={(event) => handlePaginationChange({ rowsPerPage: event.target.value || 25 })}
      />
    </Container>
  );
}

export default ImportedVehicleDefinitions;
